import { Step } from 'react-joyride';
import { Trans } from 'react-i18next';

import { DISCOVERY_TOUR_STEPS_KEYS } from '@/constants/local_storage_keys.ts';
import { StepData } from '@/providers/JoyrideProvider/JoyrideProvider.tsx';

export const discoveryTourSteps: Step[] = [
  {
    target: DISCOVERY_TOUR_STEPS_KEYS.FILTER_BUTTON,
    content: (
      <Trans i18nKey="tooltip_filter_content" components={{ br: <br /> }} />
    ),
    placement: 'bottom',
    disableBeacon: true,
    data: {} as StepData
  },
  {
    target: DISCOVERY_TOUR_STEPS_KEYS.REACTION_BUTTON,
    content: (
      <Trans i18nKey="tooltip_reaction_content" components={{ br: <br /> }} />
    ),
    placement: 'top-start',
    disableBeacon: true,
    data: {} as StepData
  }
];